module.exports = __webpack_public_path__ + "media/images/front/sp/institution-treatment-information/bnr_300_250-a9612eb4bcabcded7de803900b6fb26f.png";